import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import AlertDanger from "components/Alerts/AlertDanger"
import AlertSuccess from "components/Alerts/AlertSuccess"
import {User} from "domain-models"
import {useUser} from "hooks/StateHooks"
import Form from "mixins/form"
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React, {createRef} from "react"
import {updateUser} from "redux/actions"
import {store} from "../../../store"
import Trans from '../../../components/Trans'
import SelectInput from '../../../components/SelectInput'

type UpdateContactInformationProps = {}

type UpdateContactInformationState = {
  form: FormType
}

class UpdateContactInformation extends React.Component<UpdateContactInformationProps, UpdateContactInformationState> {
  private user = useUser()
  private form: FormType = new Form({name: this.user.employee.Name, email: this.user.employee.Email, locale: this.user.locale})
  private emailRef = createRef<HTMLInputElement>()
  private nameRef = createRef<HTMLInputElement>()

  constructor(props: UpdateContactInformationProps) {
    super(props)
    this.state = {
      form: this.form,
    }
  }

  update = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    this.form.name = this.nameRef.current ? this.nameRef.current.value : null
    this.form.email = this.emailRef.current ? this.emailRef.current.value : null

    await this.setState({
      form: this.form
    })

    const newUser = await Http.put<User>('/employee/' + this.user.ars_id, {
      state: this,
      form: this.state.form
    })

    if (!this.state.form.errors.hasErrors()) {
      await store.dispatch(updateUser(newUser))
    }

    location.reload()
  }

  render() {
    const locales = [
      {value: 'de', label: 'Deutsch'},
      {value: 'en', label: 'Englisch'},
      {value: 'fr', label: 'Französisch'},
    ]
    return (
      <div className="flex flex-col lg:flex-row flex-wrap w-full">
        <div className="flex flex-col lg:flex-row w-full">
          <div className="text-gray-600 font-semibold tracking-wide w-full lg:w-1/3 text-center lg:text-left flex flex-col">
            <div className="whitespace-no-wrap">
              <Icon icon="id-card"/>
              <span> <Trans>Benutzerdaten</Trans></span>
            </div>
          </div>
          <form className="w-full lg:w-2/3">
            {this.state.form.successful ?
              <AlertSuccess>
                <span><Trans>Ihre Benutzerdaten wurden erfolgreich gespeichert.</Trans></span>
              </AlertSuccess>
              : null}
            <div>
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Name</Trans></label>
              <input name="name" type="text" ref={this.nameRef} defaultValue={this.state.form.name} className="appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
              {
                this.state.form.errors.has('name') ?
                  <AlertDanger>
                    <span><Trans>Der Name muss ausgefüllt sein.</Trans></span>
                  </AlertDanger>
                  : null
              }
            </div>

            <div className="mt-4">
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>E-Mail Addresse</Trans></label>
              <input name="email" type="text" ref={this.emailRef} defaultValue={this.state.form.email} className="appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
              {
                this.state.form.errors.has('email') ?
                  <AlertDanger>
                    <span><Trans>Die E-Mail Adresse muss gültig sein.</Trans></span>
                  </AlertDanger>
                  : null
              }
            </div>

            <div className="mt-4">
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Sprache</Trans></label>

              <SelectInput required={true} value={this.state.form.locale} options={locales} setOption={target => {
                this.form.locale = target
                this.setState({form: this.form})
              }} labelField='label' keyField='value'/>
            </div>

            <div className="mt-4 flex justify-end">
              <button className={"rounded bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 font-semibold" + (this.state.form.busy ? ' cursor-not-allowed opacity-75' : '')} onClick={this.update}>
                {this.state.form.busy ?
                  <Icon icon="spinner" spin={true}/>
                  :
                  <Icon icon="user-edit"/>
                }
                <span> <Trans>Speichern</Trans></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default UpdateContactInformation
